import { post } from '../axios/axios.js'//引入封装的文件中的post方法
import { get } from '../axios/axios.js'//引入封装的文件中的get方法
export default {
    login(params) {
        return post('manager/login/login', params)
    },

    resetPwd(params){
        return post('manager/user/resetPwd',params)
    },
    getRouters(){
        return post('manager/power/getPower')
    },
    //上传图片
    upload(params) {
        return post('general/common/getWebUploadToken', params)
    },
    uploadSTS(params) {
        return post('general/common/getStsUploadToken', params)
    },
    //获取配置项
    getConfig() {
        return post('general/common/getConfig')
    },

    // 获取省市区
    getProvince() {
        return post('general/common/getProvince')
    },
    getCity(params) {
        return post('general/common/getCity',params)
    },
    getArea(params) {
        return post('general/common/getArea',params)
    },

    //轮播图列表
    bannerList(params) {
        return post('manager/banner/getList',params)
    },
    bannerDetail(params) {
        return post('manager/banner/detail',params)
    },
    editBanner(params) {
        return post('manager/banner/save',params)
    },
    addBanner(params) {
        return post('manager/banner/add',params)
    },
    removeBanner(params) {
        return post('manager/banner/remove',params)
    },
    switchStatus(params) {
        return post('manager/banner/switchStatus',params)
    },


    //班级
    classList(params) {
        return post('manager/group/getList',params)
    },
    editClass(params) {
        return post('manager/group/save',params)
    },
    addClass(params) {
        return post('manager/group/add',params)
    },
    removeClass(params) {
        return post('manager/group/remove',params)
    },
    detailClass(params) {
        return post('manager/group/detail',params)
    },
    classSelectList(params) {
        return post('manager/group/getSelectList',params)
    },
    detailRelation(params) {//关联详情
        return post('manager/group/getRelevancyCtable',params)
    },
    classTimetable(params) {//获取对应的班级课表
        return post('manager/group/getCTableItemList',params)
    },
    relatedCourses(params) {//创建直播间
        return post('manager/group/relationCtable',params)
    },
    editRelatedCourses(params) {//编辑直播间
        return post('manager/group/saveRelationCtable',params)
    },
    detailRelatedCourses(params) {//
        return post('manager/group/relationDetail',params)
    },
    getDownloadFile(params) {//
        return post('manager/group/getDownloadFile',params)
    },
    createTask(params) {//
        return post('manager/group/createDownload',params)
    },
    


    //机构
    organizationList(params) {
        return post('manager/organ/getList',params)
    },
    editOrganization(params) {
        return post('manager/organ/save',params)
    },
    addOrganization(params) {
        return post('manager/organ/add',params)
    },
    removeOrganization(params) {
        return post('manager/organ/remove',params)
    },
    detailOrganization(params) {
        return post('manager/organ/detail',params)
    },
    //期次
    periodList(params) {
        return post('manager/period/getList',params)
    },
    editPeriod(params) {
        return post('manager/period/save',params)
    },
    addPeriod(params) {
        return post('manager/period/add',params)
    },
    removePeriod(params) {
        return post('manager/period/remove',params)
    },
    detailPeriod(params) {
        return post('manager/period/detail',params)
    },
    periodSelectList(params) {
        return post('manager/period/getSelectList',params)
    },
   



    //助教
    assistantSelectList(params) {
        return post('manager/assistant/getSelectList',params)
    },
    assistantList(params) {
        return post('manager/assistant/getList',params)
    },
    deleteAssistant(params) {
        return post('manager/assistant/remove',params)
    },
    addAssistant(params) {
        return post('manager/assistant/add',params)
    },
    detailAssistant(params) {
        return post('manager/assistant/detail',params)
    },
    editAssistant(params) {
        return post('manager/assistant/save',params)
    },



    //讲师
    lecturerSelectList(params) {
        return post('manager/teacher/getSelectList',params)
    },
    lecturerList(params) {
        return post('manager/teacher/getList',params)
    },
    deleteLecturer(params) {
        return post('manager/teacher/remove',params)
    },
    addLecturer(params) {
        return post('manager/teacher/add',params)
    },
    detailLecturer(params) {
        return post('manager/teacher/detail',params)
    },
    editLecturer(params) {
        return post('manager/teacher/save',params)
    },



    // 学员
    studentList(params) {//已报名，班级下
        return post('manager/student/getStudentList',params)
    },
    noRegisterList(params) {//未报名列表
        return post('manager/student/getEnrollList',params)
    },
    deleteStudent(params) {
        return post('manager/student/remove',params)
    },
    addStudent(params) {
        return post('manager/student/add',params)
    },
    detailStudent(params) {
        return post('manager/student/detail',params)
    },
    
    editStudent(params) {
        return post('manager/student/save',params)
    },
    //实名认证审核
    certificateStudent(params) {
        return post('manager/student/certificate',params)
    },
    // 入学登记表审核
    recordExamine(params) {
        return post('manager/student/recordExamine',params)
    },
    // 学员导入
    // importStudent(params) {
    //     return post('manager/student/import',params)
    // },
    // 分配班级
    distributionClass(params) {
        return post('manager/student/distributeGroup',params)
    },
    // 获取入学登记表
    getEnrollment(params) {
        return post('manager/student/getStudentRecord',params)
    },
    
    // 资讯
    informationList(params) {
        return post('manager/information/getList',params)
    },
    deleteInformation(params) {
        return post('manager/information/remove',params)
    },
    addInformation(params) {
        return post('manager/information/add',params)
    },
    detailInformation(params) {
        return post('manager/information/detail',params)
    },
    editInformation(params) {
        return post('manager/information/save',params)
    },


    // 学员管理
    // 协议书
    agreementList(params) {
        return post('manager/agreement/getList',params)
    },
    // exportStudentAgreement(params) {
    //     return post('manager/agreement/exportOne',params)
    // },
    // exportAllAgreement(params) {
    //     return post('manager/agreement/export',params)
    // },
    //期末评估
    assessList(params) {
        return post('manager/assess/getList',params)
    },
    assessDetail(params) {
        return post('manager/assess/detail',params)
    },
    assessCheck(params) {
        return post('manager/assess/check',params)
    },


    // 想法分析书
    // exportStudentIdea(params) {
    //     return post('manager/idea/exportOne',params)
    // },
    // exportAllIdea(params) {
    //     return post('manager/idea/export',params)
    // },
    ideaList(params) {
        return post('manager/idea/getList',params)
    },
    detailIdea(params) {
        return post('manager/idea/detail',params)
    },
    checkIdea(params) {
        return post('manager/idea/check',params)
    },
    

    // 学习进度
    learnprocessList(params) {
        return post('manager/learnProcess/getList',params)
    },

    // 学习记录
    learnRecordList(params) {
        return post('manager/studentManager/learnList',params)
    },

    // 意见反馈
    feedbackList(params) {
        return post('manager/studentManager/getFeedbackList',params)
    },
    feedbackListDetail(params) {
        return post('manager/studentManager/feedbackDetail',params)
    },

    // 入学登记表
    recordList(params) {
        return post('manager/record/getList',params)
    },
    // exportRecord(params) {
    //     return get('manager/record/export',params)
    // },

    // 视频签到
    signList(params) {
        return post('manager/sign/getList',params)
    },
    // exportSign(params) {
    //     return post('manager/sign/export',params)
    // },

    // 创业计划书
    sybplanList(params) {
        return post('manager/sybplan/getList',params)
    },
    checkSybplan(params) {
        return post('manager/sybplan/check',params)
    },
    detailSybplan(params) {
        return post('manager/sybplan/detail',params)
    },
    // exportSign(params) {
    //     return post('manager/sign/export',params)
    // },
    // 学员管理-考试
    studentExamList(params) {
        return post('manager/studentManager/examList',params)
    },
    studentExamDetail(params) {
        return post('manager/studentManager/examDetail',params)
    },
    studentExamCheck(params) {
        return post('manager/studentManager/examCheck',params)
    },
    studentExamResit(params) {
        return post('manager/studentManager/examResit',params)
    },
    // 学生列表
    basicsStudent(params) {
        return post('manager/studentManager/getStudentList',params)
    },



    //   考试
    examList(params) {
        return post('manager/exam/getPaperList',params)
    },
    examAdd(params) {
        return post('manager/exam/paperAdd',params)
    },
    examDetail(params) {
        return post('manager/exam/paperDetail',params)
    },
    examUpdate(params) {
        return post('manager/exam/paperSave',params)
    },

    // 题目
    subjectSelect(params) {
        return post('manager/exam/getSelectQuestion',params)
    },
    subjectUpdate(params) {
        return post('manager/exam/questionSave',params)
    },
    subjectRemove(params) {
        return post('manager/exam/questionRemove',params)
    },
    subjectAdd(params) {
        return post('manager/exam/questionAdd',params)
    },
    subjectList(params) {
        return post('manager/exam/getQuestionList',params)
    }, 
    subjectDetail(params) {
        return post('manager/exam/questionDetail',params)
    },



    // 作业管理
    taskList(params) {
        return post('manager/work/getList',params)
    },
    taskAdd(params) {
        return post('manager/work/add',params)
    },
    taskDetail(params) {
        return post('manager/work/detail',params)
    },
    taskUpdate(params) {
        return post('manager/work/save',params)
    },
    taskDelete(params) {
        return post('manager/work/remove',params)
    },
    
    // 题目
    taskSubjectSelect(params) {
        return post('manager/work/getSelectQuestion',params)
    },
    taskSubjectUpdate(params) {
        return post('manager/work/questionSave',params)
    },
    taskSubjectRemove(params) {
        return post('manager/work/questionRemove',params)
    },
    taskSubjectAdd(params) {
        return post('manager/work/questionAdd',params)
    },
    taskSubjectList(params) {
        return post('manager/work/questionList',params)
    }, 
    taskSubjectDetail(params) {
        return post('manager/work/questionDetail',params)
    },

}